/** STARTING WITH COPY-PASTE FROM GRAPHIC STAMP SELECTOR -- see difference and maybe combo code with graphic  */

require('./style.less');

var Marionette = require('marionette'),
    _ = require('underscore');

require('chosenBundle');


module.exports = Marionette.ItemView.extend({

    tagName: 'select',
    className: 'textStampSelect',
    template: require('./template.hbs'),

    initialize: function( options ) {

        this.userStamps = options.userStamps;
        this.initialStamp = options.initialStamp;
        this.stampIsDerivedFromPageNote = this.initialStamp && this.initialStamp.isDerivedFromPageNote();

        this.onChange = options.onChange; // TODO: make the graphic one this ...
        this.numberOptions = 0; // TODO: template in other class ...

    },
    serializeData: function() {

        // ( its a 'cached' clone of the original user stamp model attributes, reference is still in tact )
        var myStampsArray = this.userStamps.getDataToPopulateCreateStampDropDown();

        var myStampDataToPopulateDropdown = [];

        if ( !this.stampIsDerivedFromPageNote ) {

            myStampDataToPopulateDropdown = [].concat( myStampsArray );

        } else {

            var stampFromTemplate = this.initialStamp.attributes;
            stampFromTemplate.isFromNote = true;
            myStampDataToPopulateDropdown = [ this.initialStamp.attributes ].concat( myStampsArray ); // ( make this this first so it is selected -- template only interest in the attributes )

        }

        this.numberOptions = myStampDataToPopulateDropdown.length;

        return {
            stamps: myStampDataToPopulateDropdown
        };


    },

    //  Maybe we don't select one automatically for new stamps?
    onRender: function() {

        this.initialStamp && this.$el.val( this.initialStamp.get('id') );

        // disable if there are no more choices to chose from -- do in template?
        if ( this.numberOptions < 2 )
            this.$el.attr('disabled', 'disabled');

    },

    onShow: function() {

        this.$el
            .chosen({
                width: '100%', // Do in CSS?
                placeholder_text_single: 'Select a Stamp...'
            })
            .on('change', _.bind( this._onStampSelectChange, this) );


    },

    _onStampSelectChange: function( e, params ) {

        this.onChange( parseFloat( params.selected ) );

    },

    onBeforeDestroy: function() {
        this.$el
            .off()
            .chosen('destroy');

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/textStamp/textStampSelector/view.js
 ** module id = 325
 ** module chunks = 0
 **/